import React from 'react'

const ExternalDone = () => {
  return (
    <div>ExternalDone</div>
  )
}

export default ExternalDone